<template>
  <ion-page>
    <master-layout pageTitle="اطلاعات سفارش">
          <Loading :is="!orderLoaded" v-if="!orderLoaded"></Loading>
          <div v-if="orderLoaded">
            <div v-if="order" class="p-2">
              <h5>سفارش  : {{order.order_number}}</h5>
              <div> تاریخ ثبت : {{order.created_date}}</div>
              <ion-card>
                <ion-card-content>
                  <div class="info-items">
                    <div>تحویل گیرنده :</div>
                    <div>
                      {{ order.address.fullname }}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>شماره تماس :</div>
                    <div>
                      {{ order.address.phone}}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>تعداد کالا :</div>
                    <div>
                      {{orderItems.length}}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>مبلغ قابل پرداخت :</div>
                    <div>
                      {{order.remaining_payment_amount}}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>مبلغ کل :</div>
                    <div>
                      {{order.total}}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>تخفیف :</div>
                    <div>
                      {{order.discount_amount + order.special_discount_total}}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>آدرس :
                      {{order.address.address}}
                    </div>
                  </div>
                </ion-card-content>
              </ion-card>
              <router-link :to="'/payment/'+order._id">
              <ion-button v-if="order.status === 0" color="success" expand="full">پرداخت سفارش</ion-button>
              </router-link>
              <ion-card>
                <ion-card-content>
                  <div class="info-items text-success">
                    <div>وضعیت :
                      {{order.status_label}}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>زمان تقریبی تحویل :</div>
                    <div>
                      {{order.send_date}}
                      روز بعد از پرداخت
                    </div>
                  </div>
                  <div class="info-items">
                    <div>مبلغ مرسوله :</div>
                    <div>
                      {{order.subtotal}}
                    </div>
                  </div>
                  <div class="info-items">
                    <div>هزینه ارسال :</div>
                    <div>
                      {{order.shipping_cost}}
                    </div>
                  </div>
                </ion-card-content>
              </ion-card>

              <h4>آیتم های سفارش</h4>
              <div id="plans-list">
                <div v-for="item in orderItems" :key="item._id" class="brand-model-item item">
                  <div class="thumbnail">
                    <img :src="item.thumbnail_url"/>
                  </div>
                  <div class="title">
                    <h4>{{ item.item_title }}</h4>
                    <div class="c-attr">{{item.attr_string}}</div>
                  </div>
                  <div v-if="item.provider_id">
                    <div class="mb-1">
                      <i class="far fa-store"></i>
                      {{item.provider_title}}
                    </div>
                  </div>
                  <div class="justify-between mb-1 quantity">
                    <div> تعداد :</div>
                    <div>{{item.quantity}}</div>
                  </div>
                  <div class="price">
                      <div class="justify-between mb-1">
                        <div>قیمت :</div>
                        <div>
                          <div v-if="item.special_discount">
                            <del><money :number="item.original_price"></money></del>
                          </div>
                          <money :number="item.price"></money>
                          تومان
                        </div>
                      </div>
                      <div class="justify-between mb-1">
                        <div>جمع :</div>
                        <div>
                          <money :number="item.total"></money>
                          تومان
                        </div>
                      </div>

                  </div>
                  <div class="justify-between">
                    <div v-if="item.unit_type === 'big'" class=" text-danger">
                      واحد :
                      {{item.bigger_unit_title}}
                    </div>
                    <div v-if="item.unit_type === 'big'" class=" text-danger">
                      تعداد در هر {{item.bigger_unit_title}} :
                      {{item.bigger_unit_quantity}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>

    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage, IonCard, IonCardContent, IonCardHeader} from '@ionic/vue';
import Money from "@/components/Money";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    Money,
    IonPage, IonCard, IonCardContent, IonCardHeader
  },
  data()
  {
    return {
      id: null,
      orderLoaded: false,
      order: null,
      error: null,

    }
  },
  async created()
  {
    this.id = this.$route.params.id;
    const result = await this.getOrder(this.id);
    if (result)
    {
      if (result.ok)
      {
        this.orderLoaded = true;
        this.order = result.order;
        this.orderItems = result.order_items;
      }
      else
      {
        this.orderLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.orderLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  methods: {
    ...mapActions("app", {
    }),
    ...mapActions("shop", {
      getOrder: 'getOrder'
    }),
  }
}

</script>

<style scoped>
.p-2
{
  padding: 5px;
}
.info-items{
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1px solid #c0c0c091;
}
#plans-list {
  overflow-x: auto;
  padding: 15px 5px;
  display: flex;
  flex-direction: row;
}
.brand-model-item {
  display: block;
  height: 450px;
  margin-left: 15px;
  width: 100%;
  min-width: 250px;
}
.thumbnail{
  height: 186px;
}
.thumbnail img {
  height: 180px;
  margin: 0 auto;
}
.brand-model-item > *{
  max-width: 100%;
}
.title h4 {
  color: #172e79;
  font-size: 20px !important;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
  white-space: break-spaces;
}
.price del {
  display: inline;
  color: red;
}
.price div {
  display: block;
  color: #222222;
}
.price {
  height: 85px;
  font-size: 15px;
}
.c-attr {
  height: 27px;
  font-size: 15px;
}
.justify-between
{
  display: flex !important;
  justify-content: space-between;
}
.percent {
  background: #eb445a;
  color: white;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 3px;
}
.quantity
{
  font-size: 15px;
  margin-bottom: 5px;
}
</style>